//import { DispatchSearchType } from "../enums/dispatchSearchType";

//Don't forget to adjust/add <cp-filtered-items> on widget to include any new/removed filters.

export class WidgetSearch
{
    customSearch: boolean = false;
    emptySearch: boolean = false;
    active: boolean = true;
    customerId: any = null;
    customerIds: string[];
    customerInclusivity: boolean = true;
    classIds: any[];
    dispatchSearchType: any;
    states: string[];
    acctMgrId: any;
    acctMgrIds: string[];
    contractAdminId: any;
    contractAdminIds: string[];
    serviceMgrId: any;
    billerId: any;
    billerIds: string[];
    buyerIds: string[];
    companyId: any;
    userId: any;
    startDate: Date;
    endDate: Date;
    salespersonId: any;
    salesPersonIds: string[];
    statusId: any; 
    statusIds: string[]; 
    out_S: string;
    out_Id: any;
    constructionDispatches: boolean = false;
    srvConst: any;
    srvConstInt: any;
    locationId: any;
    locationIds: string[];
    technicianId: any;
    technicians: string[];
    divisionIds: string[];
    supplierId: any;
    dispatchNbr: any;
    orderNbr: any;
    inventoryNbr: any;
    quoteNbr: any;
    invoiceNbr: any;
    salesPersonId: any;
    purchaserPersonIds: any;
    statuses: string[];
    openVendorOnly: any;
    fiscalYear: any;
    invoiceSalesSummaryTypes: any;
    invoiceStatus: any;
    invoiceStatuses: string[];
    assignmentStatus: any;
    regionIds: string[];
    discreetBillerIds: string[];
    defaultSubmitterIds: string[];
    requestedByIds: string[];
    orderStatuses: string[];
    isSub: any;
    suppliers: string[]; 
    onCallRegions: string[]; 
    techCreated: any;
    techCreatedInt: any;
    disputeAmmountInt: any;
    creditMemoStatusIds: string[];
    creditReasonCodeIds: string[];
    accountManagerName: string;
    defaultBillerName: string;
    isConstruction: any;
    daysAged: string;
    userCreditMemoApprLimit: number;
    priorityIds: any;
    projectManagerIds: string[];
    rankOrderIds: any;
}
